import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import editIcon from "svg/edit_blue.svg";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import EditSelectProject from "components/siteRepo/editSite/selectProject";
import EditSiteDetails from "components/siteRepo/editSite/siteDetails";
import "./style.scss";

const EditSite = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { siteId } = useParams();

  return (
    <div className="container-fluid search-form-container create-site d-flex flex-column">
      <div className="search-form-container__title d-flex align-items-center">
        <img src={editIcon} alt="Edit site icon" className="create-site__icon" />
        <span className="search-form-container__title--text">Edit Site Information</span>
      </div>
      <Tabs
        transition={false}
        activeKey={location.hash}
        onSelect={(key) => navigate(`/siteRepo/editSite/${siteId}${key}`)}
      >
        <Tab eventKey="#select-project-editable" title="Import a Project">
          <EditSelectProject />
        </Tab>
        <Tab eventKey="#site-details-editable" title="Site Details">
          <EditSiteDetails />
        </Tab>
      </Tabs>
    </div>
  );
};

export default EditSite;
